import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getPlacementGradientStyles } from '../styles';

const GradientImpl = ({
  gradientClassName, classes,
}) => (
  <div className={classnames(classes.placementCardGradientRoot, gradientClassName)} />
);

GradientImpl.propTypes = {
  gradientClassName: PropTypes.string,
  classes: PropTypes.shape({
    placementCardGradientRoot: PropTypes.string,
  }).isRequired,
};

GradientImpl.defaultProps = {
  gradientClassName: undefined,
};

export const PlacementGradient = withUAPLThemedStyles(
  GradientImpl,
  getPlacementGradientStyles,
  { componentName: 'PlacementGradient ' }
);
